import { useContext } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";

function SvgComponent(props: any) {
  const {
    info: { theme },
  } = useContext(AppInfoContext);

  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_968_117)">
        <path
          d="M17.0006 8.93682C17.0006 13.6087 13.2132 17.3961 8.54132 17.3961C3.86941 17.3961 0.0820312 13.6087 0.0820312 8.93682C0.0820312 8.93884 8.54132 0.478464 8.54132 0.477539C13.2132 0.477539 17.0006 4.26492 17.0006 8.93682Z"
          fill="#0052B4"
        />
        <path
          d="M8.51562 8.93723H8.5383C8.5383 8.92961 8.5383 8.9222 8.5383 8.91455C8.53075 8.92213 8.52321 8.92968 8.51562 8.93723Z"
          fill="#F0F0F0"
        />
        <path
          d="M8.54131 4.89107C8.54131 3.4026 8.54131 2.42731 8.54131 0.477539H8.53989C3.86858 0.478332 0.0820312 4.26535 0.0820312 8.93682H4.49556V6.45155L6.98084 8.93682H8.51871C8.52624 8.92929 8.53378 8.92176 8.54135 8.91419C8.54135 8.34428 8.54135 7.83576 8.54135 7.37642L6.056 4.89107H8.54131Z"
          fill="#F0F0F0"
        />
        <path
          d="M4.36383 1.58057C3.04078 2.33394 1.94084 3.43385 1.1875 4.7569V8.93648H3.39428V3.78742V3.78735H8.54341C8.54341 3.09134 8.54341 2.42828 8.54341 1.58057H4.36383V1.58057Z"
          fill="#D80027"
        />
        <path
          d="M8.54185 7.89657L5.53632 4.89111H4.49609V4.89118L8.54178 8.93684H8.54185C8.54185 8.93684 8.54185 8.21955 8.54185 7.89657Z"
          fill="#D80027"
        />
        <path
          d="M13.3207 5.62608L12.2173 5.99389L11.1139 5.62608L10.7461 4.70659L11.1139 3.78711H13.3207L12.9529 4.70659L13.3207 5.62608Z"
          fill="#ACABB1"
        />
        <path
          d="M9.64453 5.62598V9.6717C9.64453 11.6425 12.2191 12.2463 12.2191 12.2463C12.2191 12.2463 14.7937 11.6425 14.7937 9.6717V5.62598H9.64453Z"
          fill="#338AF3"
        />
        <path
          d="M9.875 10.6303C10.5079 11.8453 12.2175 12.2464 12.2175 12.2464C12.2175 12.2464 13.9271 11.8453 14.56 10.6303L12.2175 6.72949L9.875 10.6303Z"
          fill="#6DA544"
        />
        <path
          d="M14.7937 9.63082L12.2191 5.62598L9.64453 9.63085V9.6717C9.64453 10.0364 9.73289 10.3543 9.8766 10.6302L12.2191 6.98624L14.5616 10.6301C14.7053 10.3542 14.7937 10.0364 14.7937 9.67166V9.63082Z"
          fill="#FFDA44"
        />
      </g>
      <defs>
        <clipPath id="clip0_968_117">
          <rect
            width="16.9186"
            height="16.9186"
            fill="white"
            transform="translate(0.0820312 0.477539)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgComponent;
